import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
// Declarar fbq en el tipo global de Window
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function AppRouter() {
  useEffect(() => {
    try {
      // Cargar el script de Facebook Pixel directamente
      const pixelId = '749776254777376';
      // Crear la función fbq si no existe
      if (!window.fbq) {
        const fbq = function () {
          fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
        };
        if (!window._fbq) window._fbq = fbq;
        window.fbq = fbq as any;
        (window.fbq as any).push = fbq;
        (window.fbq as any).loaded = true;
        (window.fbq as any).version = '2.0';
        (window.fbq as any).queue = [];
      }
      // Cargar el script de Facebook Pixel
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      // Esperar a que el script se cargue
      script.onload = () => {
        if (window.fbq) {
          // Inicializar el pixel
          window.fbq('init', pixelId);
          // Track PageView inicial
          window.fbq('track', 'PageView');
          console.log('✅ Meta Pixel initialized successfully with ID:', pixelId);
          console.log('✅ PageView event tracked');
        }
      };
      // Agregar el noscript para el pixel
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    } catch (error) {
      console.error('❌ Error initializing Meta Pixel:', error);
    }
  }, []);
  return <BrowserRouter data-id="element-13">
      <Routes data-id="element-14">
        <Route path="/" element={<App data-id="element-16" />} data-id="element-15" />
      </Routes>
    </BrowserRouter>;
}